import styled from "styled-components"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Grid, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Wrapper = styled(SectionWrapper)`
  background-color: #f5f5f5;
`

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.typography.pxToRem(44)};
  font-weight: 500;
  line-height: 48px;
  margin-bottom: 1em;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1.5rem;
    line-height: normal;
  }
`

export const Description = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.content};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  line-height: 32px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
    line-height: normal;
  }
`

export const Image = styled(CustomImage)`
  width: 100%;
  max-height: 280px;
  display: flex;
  justify-content: center;
  img {
    max-height: 280px;
    object-fit: contain !important;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-height: 380px;
    img {
      max-height: 380px;
      object-fit: contain !important;
    }
  }
`

export const ImageWrapper = styled.div`
  background-color: #f2f2f2;
  border-radius: 20px;
  border: 1px solid #d3d3d3;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TopWrapper = styled.div`
  margin-bottom: 2em;
`

export const ButtonsGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
